// Based on https://axios-http.com/docs/handling_errors
export const extractErrorMessage = (error) => {
  // The request was made and the server responded with a status code
  // that falls out of the range of 2xx
  if (error.response) {
    // General server errors
    if (error.response.data.message) {
      console.log(error.response.data.message)
      return error.response.data.message
    } else if (error.response.data.errors) {
      // Validation errors
      console.log(error.response.data.errors)
      return error.response.data.errors.map((e) => e.msg).join(', \n')
    }
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log(error.request)
    return error.request
  } else {
    // Something happened in setting up the request that triggered an Error
    console.error('Error', error.message)
    return error.message
  }
}
